import React, { Component } from 'react';
import lodash from 'lodash';

import FileUploader from 'common/util/FileUploader';

export default class FilePicker extends Component {
    constructor() {
        super();
        this.state = {
            open: false,
            timesOpened: 0
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { location } = this.props;
        const query = lodash.get(location, 'query', {});
        if (query.upload) {
            setTimeout(() => this.openFilePicker(), 150);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.open !== nextState.open) {
            return true;
        }
        return false;
    }

    open() {
        let { open, timesOpened } = this.state;
        if (!open) {
            this.setState({
                open: true,
                timesOpened: timesOpened += 1
            });
        }
    }

    close() {
        if (this.props.onClose) {
            this.props.onClose();
        }

        if (this.state.open) {
            this.setState({ open: false });
        }
    }

    openFilePicker() {
        const filePickerInput = document.querySelector('#filePicker');
        filePickerInput.click();

        this.close();
    }

    handleFileSelectedEvent(e) {
        let files;
        if (e.dataTransfer) {
            files = lodash.toArray(e.dataTransfer.files);
        }
        else {
            files = lodash.toArray(e.target.files);
        }

        if (this.props.onFileSelected) {
            this.props.onFileSelected(files);
            return;
        }
        this.uploadFiles(files);
    }

    uploadFiles(files) {
        const { allowedMimeTypes, fileExtensionLookup, binderId, institutionId, store = {} } = this.props;
        const fileUploader = new FileUploader({
            binderId,
            institutionId,
            fileExtensionLookup,
            allowedMimeTypes,
            store
        });
        fileUploader.uploadFiles(files);
    }

    getFileExtensions() {
        const { fileExtensionLookup } = this.props;
        if (fileExtensionLookup) {
            return Object
                .values(fileExtensionLookup)
                .map(ext => '.'.concat(ext))
                .join(',');
        }
    }

    getFilePickerInput() {
        const { multiple } = this.props;
        const { timesOpened } = this.state;
        return (
            <input type="file" key={timesOpened} hidden={true} id="filePicker" multiple={multiple || true}
                name="filePicker"
                accept={this.getFileExtensions()}
                onChange={e => this.handleFileSelectedEvent(e)}
                data-cy="FilePicker-filePicker" />
        );
    }

    render() {
        return this.getFilePickerInput();
    }
}
